// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"a59c9a153e374155e33c","678":"d9307d33dc4a86d50176","731":"5bece1e729bf5ded4996","843":"94d1023d09def55c6b4a","883":"c368805c9be4c86004d4"}[chunkId] + ".js";
};